import { Theme } from "@material-ui/core"
import makeStyles from "@material-ui/core/styles/makeStyles"
import React, { useContext, Fragment, useMemo } from "react"
import { CalendarContext, SelectDateRange } from "../context"
import moment from "moment"
import { timeFormatStr } from "Methods/basic"

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        height: 20,
        position: "absolute",
        bottom: 4,
        backgroundColor: "rgba(0,0,0,.6)",
        zIndex: 1,
        borderRadius: 6,
        color: "white",
        userSelect: "none",
        pointerEvents: "none",
    },
    btnGroup: {
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        marginTop: theme.spacing(4),
    },
}))
const widthMap: {[keys: number]: string} = {
    0: "0px",
    1: "13.3%",
    2: "27.7%",
    3: "41.9%",
    4: "56.3%",
    5: "70.6%",
    6: "84.8%",
    7: "99.2%",
}
const leftMap: {[keys: number]: string} = {
    0: "0px",
    1: "4px",
    2: "14.6%",
    3: "28.9%",
    4: "43.3%",
    5: "57.7%",
    6: "71.9%",
    7: "86.2%",
}
interface ComponentProps {
    placeId: number,
}

const SelectedDate = (props: ComponentProps) => {
    const {
        placeId,
    } = props
    const {  selectPlaceId, selectDateRange } = useContext(CalendarContext)
    const classes = useStyles()
    const { style, timeStr } = useMemo(() => {
        let style = {}
        let timeStr = ""
        const dateRange = selectDateRange as SelectDateRange
        if (placeId === selectPlaceId && selectDateRange) {
            const startTime = Math.min(dateRange.start.getTime(), dateRange.end.getTime())
            const endTime = Math.max(dateRange.start.getTime(), dateRange.end.getTime())
            const startDate = new Date(startTime)
            const endDate = new Date(endTime)
            const startDay = startDate.getDay() || 7
            const endDay = endDate.getDay() || 7
            style = {
                width: widthMap[endDay - startDay + 1],
                left: leftMap[startDay || 0],
                paddingLeft: endDay - startDay + 1 === 0 ? 0 : 8,
            }
            if (startTime === endTime) {
                timeStr = `${moment(startDate).format(timeFormatStr.day)}`
            } else {
                timeStr = `${moment(startDate).format(timeFormatStr.day)} - ${moment(endDate).format(timeFormatStr.day)}`
            }
        }
        return { style, timeStr }
    }, [selectPlaceId,  placeId, selectDateRange])
    return (
        <Fragment>
            <p
                className={classes.root}
                style={style}
            >
                {timeStr}
            </p>
        </Fragment>
    )
}

export default SelectedDate
